import createIcon from '../../createIcon';

/**
 * @component @name Discount
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNzg3MSAyMS41MDI5TDIuOTk3MDcgMTEuNzEyOVYxMy43MTI5QzIuOTk3MDcgMTQuMjQyOSAzLjIwNzA3IDE0Ljc1MjkgMy41ODcwNyAxNS4xMjI5TDExLjM3NzEgMjIuOTEyOUMxMi4xNTcxIDIzLjY5MjkgMTMuNDI3MSAyMy42OTI5IDE0LjIwNzEgMjIuOTEyOUwyMC40MTcxIDE2LjcwMjlDMjEuMTk3MSAxNS45MjI5IDIxLjE5NzEgMTQuNjUyOSAyMC40MTcxIDEzLjg3MjlMMTIuNzg3MSAyMS41MDI5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjM3NzEgMTcuOTEyOUMxMi4xNTcxIDE4LjY5MjkgMTMuNDI3MSAxOC42OTI5IDE0LjIwNzEgMTcuOTEyOUwyMC40MTcxIDExLjcwMjlDMjEuMTk3MSAxMC45MjI5IDIxLjE5NzEgOS42NTI5MyAyMC40MTcxIDguODcyOTNMMTIuNjI3MSAxLjA4MjkzQzEyLjI0NzEgMC43MTI5MyAxMS43MzcxIDAuNTAyOTMgMTEuMjA3MSAwLjUwMjkzSDQuOTk3MDdDMy44OTcwNyAwLjUwMjkzIDIuOTk3MDcgMS40MDI5MyAyLjk5NzA3IDIuNTAyOTNWOC43MTI5M0MyLjk5NzA3IDkuMjQyOTMgMy4yMDcwNyA5Ljc1MjkzIDMuNTg3MDcgMTAuMTIyOUwxMS4zNzcxIDE3LjkxMjlaTTcuMjQ3MDcgMy41MDI5M0M3LjkzNzA3IDMuNTAyOTMgOC40OTcwNyA0LjA2MjkzIDguNDk3MDcgNC43NTI5M0M4LjQ5NzA3IDUuNDQyOTMgNy45MzcwNyA2LjAwMjkzIDcuMjQ3MDcgNi4wMDI5M0M2LjU1NzA3IDYuMDAyOTMgNS45OTcwNyA1LjQ0MjkzIDUuOTk3MDcgNC43NTI5M0M1Ljk5NzA3IDQuMDYyOTMgNi41NTcwNyAzLjUwMjkzIDcuMjQ3MDcgMy41MDI5M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Discount = createIcon('Discount', [
  [
    'path',
    {
      d: 'M12.7871 21.5029L2.99707 11.7129V13.7129C2.99707 14.2429 3.20707 14.7529 3.58707 15.1229L11.3771 22.9129C12.1571 23.6929 13.4271 23.6929 14.2071 22.9129L20.4171 16.7029C21.1971 15.9229 21.1971 14.6529 20.4171 13.8729L12.7871 21.5029Z',
      key: '12heru',
    },
  ],
  [
    'path',
    {
      d: 'M11.3771 17.9129C12.1571 18.6929 13.4271 18.6929 14.2071 17.9129L20.4171 11.7029C21.1971 10.9229 21.1971 9.65293 20.4171 8.87293L12.6271 1.08293C12.2471 0.71293 11.7371 0.50293 11.2071 0.50293H4.99707C3.89707 0.50293 2.99707 1.40293 2.99707 2.50293V8.71293C2.99707 9.24293 3.20707 9.75293 3.58707 10.1229L11.3771 17.9129ZM7.24707 3.50293C7.93707 3.50293 8.49707 4.06293 8.49707 4.75293C8.49707 5.44293 7.93707 6.00293 7.24707 6.00293C6.55707 6.00293 5.99707 5.44293 5.99707 4.75293C5.99707 4.06293 6.55707 3.50293 7.24707 3.50293Z',
      key: '19tji5',
    },
  ],
]);

export default Discount;
